module.exports = __webpack_public_path__ + "img/scent.0599d8d3.svg";